export enum MaterialType {
    PCB = 1,
    Connector = 2,
    Housing = 3,
    Cover = 4,
    Panel = 5
}
